"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _useStyles = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Property = function Property(_ref) {
  var subtitle = _ref.subtitle,
      body1 = _ref.body1,
      body2 = _ref.body2;
  var classes = (0, _useStyles["default"])();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    component: "h4",
    className: classes.subtitle1,
    variant: "subtitle1",
    gutterBottom: true
  }, subtitle), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, body1), body2 ? /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, body2) : null);
};

Property.defaultProps = {
  body2: ''
};
Property.propTypes = {
  subtitle: _propTypes["default"].string.isRequired,
  body1: _propTypes["default"].node.isRequired,
  body2: _propTypes["default"].node
};

var PhysicalProperties = function PhysicalProperties(_ref2) {
  var logo = _ref2.logo,
      properties = _ref2.properties;
  return /*#__PURE__*/_react["default"].createElement(_core.Container, null, logo && /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], _extends({}, logo, {
    objectFit: "cover",
    objectPosition: "50% 50%"
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 2,
    mb: 4
  }, /*#__PURE__*/_react["default"].createElement(_core.Divider, {
    "aria-hidden": true
  })), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 7
  }, properties.map(function (prop) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true,
      key: prop.subtitle
    }, /*#__PURE__*/_react["default"].createElement(Property, prop));
  })));
};

PhysicalProperties.defaultProps = {
  logo: {}
};
PhysicalProperties.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  logo: _propTypes["default"].object,
  properties: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].node)).isRequired
};
var _default = PhysicalProperties;
exports["default"] = _default;